import styled from '@emotion/styled';

import { DeviceInfo } from '@ezugi/utils';

const IconText = styled.div`
  font-family: 'Montserrat', sans-serif;
  font-size: ${DeviceInfo.isHandheld ? '14px' : '12px'};
  line-height: normal;
  pointer-events: none;
`;

const DoubleIcon = () => <IconText>2x</IconText>;

export default DoubleIcon;
